import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledInfo = styled.div<{ $size: string; $readCustomSize: boolean }>`
    margin-bottom: 10px;
    width: ${({ $size, $readCustomSize }) => ($readCustomSize && $size ? `calc(${$size} - 5px)` : "100%")};
    ${({ $readCustomSize }) =>
        $readCustomSize &&
        `display: flex;
    flex-direction: column;`}

    ${({ $readCustomSize }) => !$readCustomSize && `display: flex`};

    span {
        margin: 0;
        flex: 1;
    }

    span:first-of-type {
        font-size: ${({ $readCustomSize }) => ($readCustomSize ? `var(--size-14)` : `var(--size-16)`)};
        color: var(--color-grey-800);
        @media ${breakpoints.xs} {
            font-size: var(--size-12);
        }
    }

    span:last-of-type {
        font-size: var(--size-16);
        color: var(--color-grey-900);
        word-break: break-word;
        @media ${breakpoints.xs} {
            font-size: var(--size-14);
        }
    }
`;
